// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FireTwoToneSvg from "@ant-design/icons-svg/es/asn/FireTwoTone";
import AntdIcon from '../components/AntdIcon';

var FireTwoTone = function FireTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FireTwoToneSvg
  }));
};

FireTwoTone.displayName = 'FireTwoTone';
export default React.forwardRef(FireTwoTone);